import { useQuery } from '@tanstack/react-query';
import { simProductsQueries } from 'products/sim/Inventory/queries/simProductsQueries.ts';
import { fetchSimProductsPagination } from 'products/sim/SimProductsApi/simProductsApi.ts';
import { getSearchIds } from 'common/components/Sim/Filters/SimIdSearchInput.util.tsx';
import { useValidatedSearchId } from 'common/components/Filters/hooks/useValidatedSearchId.ts';
import { useAtomValue } from 'jotai';
import {
  pageFilterAtom,
  rowsPerPageFilterAtom,
  simProductsFiltersAtom,
  simProductsSortingAtomWithStorage,
} from 'atoms/filters/sim-products.ts';

export const useSimProductsPagination = () => {
  const rowsPerPage = useAtomValue(rowsPerPageFilterAtom);
  const page = useAtomValue(pageFilterAtom);

  const filters = useAtomValue(simProductsFiltersAtom);

  const sorting = useAtomValue(simProductsSortingAtomWithStorage);

  const { tags, searchText, chosenIdType, customFields, ...otherFilters } = filters;

  const { search } = useValidatedSearchId(searchText);

  return useQuery({
    queryKey: simProductsQueries.pagination({
      searchText: search,
      chosenIdType,
      ...otherFilters,
      tags,
      sorting,
      customFields,
    }),
    queryFn: ({ signal }) =>
      fetchSimProductsPagination(
        page,
        rowsPerPage,
        {
          searchText: getSearchIds(search),
          chosenIdType: chosenIdType,
          tags,
          customFields,
          ...otherFilters,
        },
        signal,
      ),
  });
};
